/* Generated. This file cannot be edited directly. Please check codegen-subscription.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/subscriptionTypes'

const defaultOptions = {} as const
export type AdVehicleStreamHubReturnProgressSubscriptionVariables =
  Types.Exact<{
    vehicleId: Types.Scalars['ID']['input']
  }>

export type AdVehicleStreamHubReturnProgressSubscription = {
  __typename?: 'Subscription'
  fccHubReturnRequestProgress: {
    __typename?: 'FccHubReturnRequestProgress'
    vehicleId: string
    status: Types.FccHubReturnRequestStatus
  }
}

export const AdVehicleStreamHubReturnProgressDocument = gql`
    subscription AdVehicleStreamHubReturnProgress($vehicleId: ID!) {
  fccHubReturnRequestProgress(vehicleId: $vehicleId) {
    vehicleId
    status
  }
}
    `

/**
 * __useAdVehicleStreamHubReturnProgressSubscription__
 *
 * To run a query within a React component, call `useAdVehicleStreamHubReturnProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamHubReturnProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdVehicleStreamHubReturnProgressSubscription({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useAdVehicleStreamHubReturnProgressSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    AdVehicleStreamHubReturnProgressSubscription,
    AdVehicleStreamHubReturnProgressSubscriptionVariables
  > &
    (
      | {
          variables: AdVehicleStreamHubReturnProgressSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    AdVehicleStreamHubReturnProgressSubscription,
    AdVehicleStreamHubReturnProgressSubscriptionVariables
  >(AdVehicleStreamHubReturnProgressDocument, options)
}
export type AdVehicleStreamHubReturnProgressSubscriptionHookResult = ReturnType<
  typeof useAdVehicleStreamHubReturnProgressSubscription
>
export type AdVehicleStreamHubReturnProgressSubscriptionResult =
  Apollo.SubscriptionResult<AdVehicleStreamHubReturnProgressSubscription>
